$.fn.bleauPreloader = function () {
  var $elem = this,
   $preloader = $('.fb-preloader'),
   tl = new TimelineLite();
  // $preloader.append('<img src="/templates/main/images/icons/fb-icon-black.svg" class="logo-icon" />');
  // $preloader.append('<img src="/templates/main/images/icons/feels-like-fontainebleau.svg" class="tagline" />');
  // $preloader.append('<img src="/templates/main/images/icons/fb-logo-black.svg" class="logo-text" />');
  // $elem.append($preloader);
  $preloader.addClass('playing');
  tl.to('.fb-preloader', 0.5, {
    opacity: 1,
    onStart: function () {
      $('body').css('overflow', 'hidden');
    }
  }, "+=0.25");
  tl.to('.fb-preloader .logo-icon', 1, {opacity: 1}, "+=1")
   .to('.fb-preloader .logo-icon', 2, {y: '-=140%', ease: Power3.easeOut}, "+=1")
   .to('.fb-preloader .tagline', 2, {opacity: 1, scale: 1, ease: Power3.easeOut, transformOrigin: "50% 50%"}, '-=.25')
   .to('.fb-preloader .tagline', 1.5, {
     opacity: 0,
     scale: 1.25,
     ease: Power3.easeIn,
     transformOrigin: "50% 50%"
   }, '+=.25')
   .to('.fb-preloader .logo-text', 2, {opacity: 1, scale: 1, ease: Power3.easeOut, transformOrigin: "50% 50%"}, '-=.25')
   .to('.fb-preloader', 0.75, {
     opacity: 0,
     onStart: function () {
       $('body').removeAttr('style');
     },
     onComplete: function () {
       $preloader.remove();
     }
   }, '+=2');
};

function renderOwnersForm() {
  $('#existing-rez-captcha').html('');

  grecaptcha.render('existing-rez-captcha', {
    'sitekey': '6LfsoxAaAAAAAMd5mUHuHr1Kj08BEVt8Qdm1JJA2',
    'theme': 'light'
  });
};

var getClosest = function (elem, selector) {

	// Element.matches() polyfill
	if (!Element.prototype.matches) {
	    Element.prototype.matches =
	        Element.prototype.matchesSelector ||
	        Element.prototype.mozMatchesSelector ||
	        Element.prototype.msMatchesSelector ||
	        Element.prototype.oMatchesSelector ||
	        Element.prototype.webkitMatchesSelector ||
	        function(s) {
	            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
	                i = matches.length;
	            while (--i >= 0 && matches.item(i) !== this) {}
	            return i > -1;
	        };
	}

	// Get the closest matching element
	for ( ; elem && elem !== document; elem = elem.parentNode ) {
		if ( elem.matches( selector ) ) return elem;
	}
	return null;

};

// Moved return to top arrow code into a function, by moving the footerOffset variable into this function and using the actual height of the footer instead of 500, the arrow works correctly. Even with expand/collapse items on the page.
function returnToTop() {
  var footerOffset = Math.ceil($(document).innerHeight() - $('footer').height());
  if ($(window).outerWidth() > 1024 && !isTouchSupported()) {
    if ($(this).scrollTop() >= 250 && Math.ceil($(this).scrollTop() + $(this).innerHeight()) <= footerOffset) {
      $('#return-to-top').addClass('visible');
    } else {
      $('#return-to-top').removeClass('visible');
    }
  }
}

window._vis_opt_url = 'https://fontainebleau.com/imaginarygallery';
function executeTrackingCode(hide) {
  var $ = window.vwo_$ || window.$ || window.jQuery;
  $ && $('.vwo_loaded').removeClass('vwo_loaded');
  window._vwo_code = (function () {
    var account_id = 182180,
     settings_tolerance = 2000,
     library_tolerance = 2500,
     url = window._vis_opt_url || document.URL,
     use_existing_jquery = false,
     // DO NOT EDIT BELOW THIS LINE
     f = false,
     d = document;
    return {
      use_existing_jquery: function () {
        return use_existing_jquery;
      },
      library_tolerance: function () {
        return library_tolerance;
      },
      finish: function () {
        if (!f) {
          f = true;
          var a = d.getElementById('_vis_opt_path_hides');
          if (a) a.parentNode.removeChild(a);
        }
      },
      finished: function () {
        return f;
      },
      load: function (a) {
        var b = d.createElement('script');
        b.src = a;
        b.type = 'text/javascript';
        b.innerText;
        b.onerror = function () {
          _vwo_code.finish();
        };
        d.getElementsByTagName('head')[0].appendChild(b);
      },
      init: function () {
        settings_timer = setTimeout('_vwo_code.finish()', settings_tolerance);
        this.load('//dev.visualwebsiteoptimizer.com/j.php?a=' + account_id + '&u=' + encodeURIComponent(url) + '&r=' + Math.random());
        var a = d.createElement('style'),
         b = hide ? hide + '{opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;}' : '',
         h = d.getElementsByTagName('head')[0];
        a.setAttribute('id', '_vis_opt_path_hides');
        a.setAttribute('type', 'text/css');
        if (a.styleSheet) a.styleSheet.cssText = b;
        else a.appendChild(d.createTextNode(b));
        h.appendChild(a);
        return settings_timer;
      }
    };
  }());
  _vwo_settings_timer = _vwo_code.init();
}


// general site js.
$(function () {
  //check for environment (localhost, dev, cert or prod)
  var devEnv = '';
  if (window.location.href.indexOf('lh') > -1) {
    devEnv = 'lh';
  } else if ( window.location.href.indexOf('dx-fb.shs.dev') > -1 ) {
    devEnv = 'dev';
  } else if ( window.location.href.indexOf('dx-fb.shs.cert') > -1 ) {
    devEnv = 'cert';
  } else {
    devEnv = 'prod';
  }
  console.log('devEnv: '+devEnv);

  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame']
     || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame)
    window.requestAnimationFrame = function (callback, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function () {
         callback(currTime + timeToCall);
       },
       timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };

  if (!window.cancelAnimationFrame)
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };

  var headerHeight = 0,
   buffer = 0,
   consoleOffset = 0,
   today = new Date();

  // if(getQueryVariable('preloader'))
  //     eraseCookie('fontainebleau preloader');

  // if($(window).outerWidth() > 1024 && $('body').hasClass('home') && !readCookie('fontainebleau preloader')) {
  //     createCookie('fontainebleau preloader', true, 7);
  //     $('body').bleauPreloader();
  // }

  $('body').on('click', 'button.disabled', function (e) {
    e.preventDefault();
  });

  // jump to sections (eg. when clicking View All X in the console)
  // doing this with JS instead of #ids because of the fixed top bar needs to be offset
  (function (hash) {
    // the size of the pinned nav and booking console + some padding
    var offset = 200,
     // offset will only be used if window's width is greater than minWidth
     minWidth = 1025,
     jumpMap,
     $target,
     scrollY;

    if (!hash) return;

    // key is the hash and value is the target to jump to
    jumpMap = {
      'view-all-dining': '.overview-grid',
      'view-all-cabanas': '.cabanas-list',
      'view-spa-services': '.spa-grid-wrapper'
    };
    hash = hash.substr(1);
    $target = $(jumpMap[hash]);

    if ($target.length) {
      // need a slight delay for stacked masthead and what not to initialize first
      setTimeout(function () {
        scrollY = $target.offset().top

        if (window.innerWidth >= minWidth) scrollY -= offset;

        window.scrollTo(0, scrollY);
        $(window).trigger('scroll');
      }, 150);
    }
  }(window.location.hash));

  $('[data-mobile-text]').each(function () {
    if ($(window).outerWidth() >= 768) {
      if ($(this).text() != $(this).attr('data-big-src') && $(this).attr('data-text'))
        $(this).text($(this).attr('data-text'));
    }
    else {
      if ($(this).text() != $(this).attr('data-mobile-text') && $(this).attr('data-mobile-text'))
        $(this).text($(this).attr('data-mobile-text'));
    }
  });

  $('img').each(function () {
    if ($(window).outerWidth() >= 768) {
      if ($(this).attr('src') != $(this).attr('data-big-src') && $(this).attr('data-big-src')) {
        $(this).attr('src', $(this).attr('data-big-src'));
      }
    } else {
      if ($(this).attr('src') != $(this).attr('data-mobile-src') && $(this).attr('data-mobile-src'))
        $(this).attr('src', $(this).attr('data-mobile-src'));
    }
  });

  $(document).ready(function () {
    if ($('.booking-console-wrapper').length > 0)
      consoleOffset = $('.booking-console-wrapper').offset().top;

    $('.big-push img').load(function () {
      $('.smaller-pushes').each(function () {
        if ($(window).outerWidth() > 1024) {
          $(this).height($(this).parent().outerHeight());
        } else if ($(window).outerWidth() <= 1024 && $(window).outerWidth() >= 768) {
          $(this).find('.push-content').height($(this).find('.push-content').parent().outerHeight());
        } else {
          if ($(this).css('height') != 'auto' && $(this).attr('style')) {
            $(this).css('height', 'auto');
            $(this).find('.push-content').css('height', 'auto');
          }
        }
      });
    }).each(function () {
      if (this.complete) {
        $(this).trigger('load');
      }
    });

    $('.interior .masthead img').load(function () {
      if ($(window).outerWidth() > 1024 && window.pageYOffset > 1) {
        $('.interior > .wrapper').each(function () {
          $(this).attr('data-margin-top', contentTopMargin());
        });

        if (!$('.masthead').hasClass('fix')) {
          $('.masthead').addClass('fix');
          $('.wrapper').css('margin-top', $('.wrapper').attr('data-margin-top') + 'px');
          $('.masthead').hide().show(0);
        }
      } else {
        $('.interior > .wrapper').each(function () {
          $(this).attr('data-margin-top', contentTopMargin());
        });
      }
    }).each(function () {
      if (this.complete) {
        $(this).trigger('load');
      }
    });


    $('.day-at-content .hover-push a').on('focus', function() {
      $(this).attr('aria-expanded','true');
    });
    
    $('.day-at-content .hover-push a button').on('focusout', function() {
      $(this).closest('.hover-push').find('a').attr('aria-expanded','false');
    });
    
    $('.monthly-push-wrapper .hover-push a').on('focus', function() {
      $(this).attr('aria-expanded','true');
    });
    
    $('.monthly-push-wrapper .hover-push a button').on('focusout', function() {
      $(this).closest('.hover-push').find('a').attr('aria-expanded','false');
    });
    $('.overview-grid .hover-push a').on('focus', function() {
      $(this).attr('aria-expanded','true');
    }).on('focusout', function() {
      $(this).attr('aria-expanded','false');
    });
  
    $('.side-push-wrapper .hover-push a').on('focus', function() {
      $(this).attr('aria-expanded','true');
    }).on('focusout', function() {
      $(this).attr('aria-expanded','false');
    });
  
    $('.bottom-interior-pushes .push-item a').on('focus', function() {
      $(this).attr('aria-expanded','true');
    }).on('focusout', function() {
      $(this).attr('aria-expanded','false');
    });
}); // JQ document ready

if ($(document.body).hasClass('home') && (!$(document.body).hasClass('spa') && !$(document.body).hasClass('home-dining') && !$(document.body).hasClass('ifb'))
   && ($(window).outerWidth() > 1024 || !isTouchSupported())) {
    // booking console placement for homepage
    var consoleBottom = (function (w) {
      var $bc = $('.booking-console-wrapper');
      if (!$bc.length) return false;

      var $masthead = $('.masthead');
      var $w = $(w);
      var winHeight = $w.height();
      var mastHeight = winHeight - $bc.height() + 'px';
      // this is the lowest window width/height ratio that the console should stick to the bottom
      var lowestRatio = 1.423;
      // aspect ratio of the masthead images
      var magicRatio = 1.592;
      // since masthead is fixed position, this fakeelement is needed to properly place the cnosole
      var $fakeElement = $('<div/>').css({height: mastHeight});

      if ($w.width() > 1024) {
        if (windowRatio() < lowestRatio) {
          updateHeight(($w.width() / magicRatio) + 'px');
        } else {
          updateHeight(mastHeight);
        }
        $bc.before($fakeElement);
      }

      consoleOffset = $bc.offset().top;

      function windowRatio() {
        return $w.width() / winHeight;
      }

      function updateHeight(h) {
        $masthead.css({height: h});
        $fakeElement.css({height: h});
      }

      // action/height params optional
      var placeConsole = function (action, height) {
        if ($w.width() < 1024) {
          $fakeElement.detach();
          return false;
        }
        $bc.parent().has($fakeElement).length ? '' : $bc.before($fakeElement);

        if (action === 'set') {
          updateHeight(height);
        } else {
          winHeight = w.innerHeight;
          mastHeight = winHeight - $bc.height() + 'px';

          if (windowRatio() < lowestRatio) {
            updateHeight(($w.width() / magicRatio) + 'px');
          } else {
            updateHeight(mastHeight);
          }
        }

        consoleOffset = $bc.offset().top;
      };

      var timeout;
      $(window).on('resize', function () {
        clearTimeout(timeout);

        timeout = setTimeout(function () {
          window.requestAnimationFrame(placeConsole);
        }, 100);
      });

      return placeConsole;
    }(window));
  }

  $(window).on('resize', function () {
    setTimeout(function () {
      if ($(window).outerWidth() > 1024 && !isTouchSupported() && $('.booking-console-wrapper').length > 0)
        consoleOffset = $('.booking-console-wrapper').offset().top;
    }, 100);
  });


  
  $('.primary-nav-wrapper').each(function () {
    var $nav = $(this);

    $nav.on('mouseover focusin', '.with-child', function (e) {
      //This is only for desktop
      if ($('.menu-trigger').is(':visible')) { return; }
      // Update aria-expanded and aria-hidden to show the menu
      $(this).attr('aria-expanded','true');
      $(this).find('.secondary').attr('aria-hidden','false');
    });

    $nav.on('mouseout focusout', '.with-child', function (e) {
      // This is only for desktop
      if ($('.menu-trigger').is(':visible')) { return; }

      // When navigating with the keyboard, we want to make sure the menu stays open
      // if you're still focusing within the current dropdown
      if (e.type != "mouseout" && getClosest(e.relatedTarget, '.with-child[aria-expanded=true]')) { return; }
      
      // Update aria-expanded and aria-hidden to show the menu
      var $withChild = $('.with-child[aria-expanded=true]');
      $withChild.attr('aria-expanded', 'false');
      $withChild.find('.secondary').attr('aria-hidden', 'true');
    });

    $nav.on('click', '.with-child > a', function (e) {
      if ($(window).outerWidth() <= 1024) {
        e.preventDefault();
        var $withChild = $(this);
        $nav.addClass('secondary-visible');
        $nav.parent('.nav-wrapper').find('.languages').addClass('secondary-visible');
        $withChild.parent().addClass('active');
        $withChild.next('.secondary').each(function () {
          var $dupLink = $('<li><a href="' + $withChild.attr('href') + '">' + $withChild.text() + '</a></li>');
          if (!$(this).hasClass('appended')) {
            $(this).addClass('appended');
            $(this).prepend($dupLink);
            $(this).append('<li><a href="#" class="back"><i class="fa fa-chevron-left"></i>Main Menu</a></li>');

          }
        });
      }
    });

    $nav.on('click', '.back', function (e) {
      e.preventDefault();
      var $back = $(this);

      $nav.removeClass('secondary-visible');
      $nav.parent('.nav-wrapper').find('.languages').removeClass('secondary-visible');

      setTimeout(function () {
        $back.closest('.primary-nav').children('li').each(function () {
          $(this).removeClass('active');
        });
      }, 500);
    });
  });

  $('.nav-wrapper .lang-trigger').on('click', function(e){
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).next('.lang-dropdown').toggleClass('active');
   });

   $('.header .lang-trigger').on('click', function(e){
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).parent().children('.languages').show();
    $(this).parent().children('.languages').find('.lang-dropdown').toggleClass('active');

    if ( $(this).hasClass('active') ) {
      $('.menu-trigger').removeClass('active').find('.navicon').removeClass('close');
      $('.header-wrapper').find('.nav-wrapper').removeClass('show-nav');
      $(this).parent().children('.languages').show();
      $(this).parent().children('.languages').find('.lang-dropdown').addClass('active');
    }
   });

  $('.header').on('click', '.menu-trigger', function (e) {
    e.preventDefault();
    var $trigger = $(this);
    if ($trigger.hasClass('active')) {
      $trigger.removeClass('active').find('.navicon').removeClass('close');
      $trigger.closest('.header-wrapper').find('.nav-wrapper').removeClass('show-nav');
      $('.header .languages').hide();

      if ($(window).outerWidth() <= 768) {
        $('.nav-wrapper .languages').hide();
      }
    } else {
      $trigger.addClass('active').find('.navicon').addClass('close');
      $trigger.closest('.header-wrapper').find('.nav-wrapper').addClass('show-nav');
      $('.nav-wrapper .languages').show();
      $('.lang-trigger').removeClass('active');
    }
  });

  // thanks css-tricks

	//Social Influencer
	if ( $('body').attr('data-pageid') == '733' ) {
		//Required Dates
		$('#date_undecided').click(function(){
			if (this.checked) {
				$('#date_undecided').addClass('required').attr('required', 'required');
				$('#arrival_date').removeClass('required').removeAttr('required', 'required').attr('data-parsley-required', 'false').parent().removeClass('error').find('.errors-list').removeClass('filled').find('li').remove();
				$('#departure_date').removeClass('required').removeAttr('required', 'required').attr('data-parsley-required', 'false').parent().removeClass('error').find('.errors-list').removeClass('filled').find('li').remove();
			} else {
				$('#date_undecided').removeClass('required').removeAttr('required', 'required');
				$('#arrival_date').addClass('required').attr('required', 'required').attr('data-parsley-required', 'true');
				$('#departure_date').addClass('required').attr('required', 'required').attr('data-parsley-required', 'true');
			}
		});
		//show/hide Other fields
		$('[id$="_other"]').on('click', function(e){
			var $otherInput = $(this).parent();

			if ($(this).is(':checked')) {
				$otherInput.find('.other-field').addClass('active');
			} else {
				$otherInput.find('.other-field').removeClass('active');
			}
		});
		//show fields
		$('.platforms [id$="_yes"]').on('click', function(e){
			$(this).closest('.media-platform').find('.influencer-toggle').addClass('active');

			//add required fields
			if ($(this).is('#instagram_yes')) {
				$('#instagram_name').addClass('required').attr('required', 'required');
				$('#instagram_follower_count').addClass('required').attr('required', 'required');
			} else if ($(this).is('#twitter_yes')) {
				$('#twitter_name').addClass('required').attr('required', 'required');
				$('#twitter_follower_count').addClass('required').attr('required', 'required');
			} else if ($(this).is('#facebook_yes')) {
				$('#facebook_page_url').addClass('required').attr('required', 'required');
				$('#facebook_follower_count').addClass('required').attr('required', 'required');
			} else if ($(this).is('#blog_yes')) {
				$('#blog_link').addClass('required').attr('required', 'required');
				$('#blog_content_other').attr('data-parsley-required', 'true');
			}
		});

		//hide fields
		$('.platforms [id$="_no"]').on('click', function(e){
			$(this).closest('.media-platform').find('.influencer-toggle').removeClass('active');

			//remove required fields
			if ($(this).is('#instagram_no')) {
				$('#instagram_name').removeClass('required').removeAttr('required', 'required').parent().removeClass('error').find('.errors-list').removeClass('filled').find('li').remove();
				$('#instagram_follower_count').removeClass('required').removeAttr('required', 'required').parent().removeClass('error').find('.errors-list').removeClass('filled').find('li').remove();
			} else if ($(this).is('#twitter_no')) {
				$('#twitter_name').removeClass('required').removeAttr('required', 'required').parent().removeClass('error').find('.errors-list').removeClass('filled').find('li').remove();
				$('#twitter_follower_count').removeClass('required').removeAttr('required', 'required').parent().removeClass('error').find('.errors-list').removeClass('filled').find('li').remove();
			} else if ($(this).is('#facebook_no')) {
				$('#facebook_page_url').removeClass('required').removeAttr('required', 'required').parent().removeClass('error').find('.errors-list').removeClass('filled').find('li').remove();
				$('#facebook_follower_count').removeClass('required').removeAttr('required', 'required').parent().removeClass('error').find('.errors-list').removeClass('filled').find('li').remove();
			} else if ($(this).is('#blog_no')) {
				$('#blog_page_url').removeClass('required').removeAttr('required', 'required').parent().removeClass('error').find('.errors-list').removeClass('filled').find('li').remove();
				$('#blog_content_other').removeAttr('data-parsley-required', 'true').parent().removeClass('error').find('.errors-list').removeClass('filled').find('li').remove();
			}
		});

		//to fix missing error issue with parsley and checkboxes
		$('#submit').on('click', function(e){
			setTimeout(function () {
				if ($('.other-information').find('.errors-list li').length !== 0) {
					$('.other-information').addClass('error')
				}
				if ($('.blog-content').find('.errors-list li').length !== 0) {
					$('.blog-content').addClass('error')
				}
			}, 100);
		});
  }
  
  $('#topic').on('change',function(){
    if( $(this).val()==="Existing Reservations"){
    $("#hotel_confrm_contnr").show()
    }
    else{
    $("#hotel_confrm_contnr").hide()
   }
   
});
  //Home scroll down button
  $(".home-scroll-trigger").on("click", function (e) {
    e.preventDefault();
    $("body, html").unbind().animate({scrollTop: $('.day-at-wrapper').offset().top - 70}, 600);
  });

  $('.masthead-nav').each(function () {
    var $el, leftPos, newWidth,
     $mastheadNav = $(".masthead-nav");

    $mastheadNav.append("<div class='magic-line'></div>");
    var $magicLine = $mastheadNav.find(".magic-line");

    $magicLine
     .width($mastheadNav.find('.active').width())
     .css("left", $mastheadNav.find('.active').position().left)
     .data("origLeft", $mastheadNav.find('.active').position().left)
     .data("origWidth", $mastheadNav.find('.active').width());

    if (!isTouchSupported()) {
      $(".masthead-nav .column .trigger").hover(function () {
        $el = $(this);
        leftPos = $el.parent().position().left;
        newWidth = $el.parent().width();
        $magicLine.stop().animate({
          left: leftPos,
          width: newWidth
        });
      }, function () {
        $magicLine.stop().animate({
          left: $mastheadNav.find('.active').position().left,
          width: $mastheadNav.find('.active').width()
        });
      });
    }
  });

  $(window).on('resize', function () {
    if (($('body').hasClass('home')) && (!$('body').hasClass('ifb-home'))) {
      setTimeout(function () {
        if ($(window).outerWidth() > 1024) {
          var $el, leftPos, newWidth,
           $mastheadNav = $(".masthead-nav"),
           $magicLine = $mastheadNav.find('.magic-line');

          if ($magicLine.length) {
            $magicLine
             .width($mastheadNav.find('.active').width())
             .css('left', $mastheadNav.find('.active').position().left);
          }
        }
      }, 100);
    }
  });

  if ( !$('body').hasClass('experiences-dining')){
    $('.mastheads').slick({
      accessibility: true,
      dots: false,
      infinite: true,
      speed: 500,
      fade: true,
      autoplay: true,
      pauseOnHover: false,
      responsive: [{
        breakpoint: 1024,
        settings: {
          infinite: true
        }
      }]
    });
  } else {
    $('.mastheads').slick({
      accessibility: true,
      dots: false,
      infinite: true,
      speed: 500,
      fade: true,
      autoplay: false,
      pauseOnHover: true,
      pauseOnFocus: true,
      responsive: [{
        breakpoint: 1024,
        settings: {
          infinite: true,
          autoplay: false,
          pauseOnHover: true,
          pauseOnFocus: true,
        }
      }]
    });
  }

  if (($('body').hasClass('home')) && (!$('body').hasClass('home-dining')) && (!$('body').hasClass('spa'))) {

    $('.mastheads').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      currentSlide = nextSlide + 1;

      $('.mastheads-content').find('.masthead-content-wrapper').each(function () {
        $(this).removeClass('active');
      });
      $('.mastheads-content').find('.masthead-content-wrapper[data-masthead-index="' + currentSlide + '"]').addClass('active');

      if ($(window).outerWidth() > 1024) {
        var $el, leftPos, newWidth,
         $mastheadNav = $(".masthead-nav"),
         $magicLine = $mastheadNav.find('.magic-line');

        $mastheadNav.find('.column').each(function () {
          $(this).removeClass('active');
        });

        $mastheadNav.find('.column[data-masthead-index="' + currentSlide + '"]').addClass('active');

        leftPos = $mastheadNav.find('.column[data-masthead-index="' + currentSlide + '"]').position().left;
        newWidth = $mastheadNav.find('.column[data-masthead-index="' + currentSlide + '"]').width();

        $magicLine.stop().animate({
          left: leftPos,
          width: newWidth
        });
      } else {
        refreshTrigger(currentSlide, nextSlide);
      }
    });
  }

  $('.masthead-wrapper').on('click', '.trigger', function (e) {
    e.preventDefault();
    var $trigger = $(this),
     mastheadIndex = $(this).parent().attr('data-masthead-index');
     $('#vegas-video').trigger('play');
    if ($(window).outerWidth() <= 1024) {
      $trigger.closest('.masthead-nav').find('.column').each(function () {
        $(this).removeClass('active');
      });
      $trigger.parent().addClass('active');
      $('.mastheads').slick('slickGoTo', mastheadIndex - 1);
      $('.mastheads').slick('slickPause');
      $('.mastheads-content').addClass('show');
    } else {
      $trigger.closest('.masthead-nav').find('.column').each(function () {
        $(this).removeClass('active');
      });
      $trigger.parent().addClass('active');
      $('.mastheads').slick('slickGoTo', mastheadIndex - 1);
      $('.mastheads').slick('slickPause');
      if (window.innerHeight < 800) {
        if ('undefined' !== typeof consoleBottom) consoleBottom('set', 800);
      }

      $('.mastheads-content').addClass('show');
      $('.header-wrapper').addClass('no-border');
    }
  });

  $('.masthead-wrapper').on('click', '.close-content', function (e) {
    e.preventDefault();
    $('.mastheads-content').removeClass('show');
    $('.header-wrapper').removeClass('no-border');
    $('.mastheads').slick('slickPlay');
    if ('undefined' !== typeof consoleBottom) consoleBottom();
  });

  // end masthead

  $('.day-at-wrapper').each(function () {
    var $el = $(this),
     leftPos, newWidth,
     $dayAtNav = $el.find('.day-at-nav'),
     $dayAtContent = $el.find('.day-at-content'),
     currentHour = today.getHours(),
     range = 'morning';

    $dayAtNav.append("<div class='magic-line'></div>");
    var $magicLine = $el.find(".magic-line");

    if (currentHour >= 4 && currentHour < 12) {                                  // AM
      range = 'morning';
    } else if (currentHour >= 12 && currentHour < 16) {                          // Noon
      range = 'afternoon';
    } else if (currentHour >= 16 && currentHour < 22) {                          // PM
      range = 'evening';
    } else {                                                                    // Late Night
      range = 'late-night';
    }

    $dayAtNav.find('#' + range).addClass('active');
    $dayAtContent.find('.time-push-wrapper[data-time="' + range + '"]').each(function () {
      $(this).addClass('active');
    });

    $magicLine.width($dayAtNav.find('.active a').width()).css("left", $dayAtNav.find('.active a').position().left);

    $('.day-at-nav').on('click', 'a', function (e) {
      e.preventDefault();
      var $trigger = $(this),
       time = $(this).parent().attr('id'),
       prevTime = $dayAtNav.find('.active').attr('id'),
       contentH = $dayAtContent.outerHeight();

      $dayAtContent.css('height', contentH);

      $dayAtNav.find('li').each(function () {
        $(this).removeClass('active');
      });

      $dayAtNav.find('li').each(function () {
        $(this).removeClass('active');
      });

      $trigger.parent().addClass('active');

      leftPos = $trigger.position().left;
      newWidth = $trigger.width();

      $magicLine.stop().animate({
        left: leftPos,
        width: newWidth
      });

      var day_Push = new TimelineLite({overwrite: 'all'});

      day_Push.set($dayAtContent.find('.time-push-wrapper'), {clearProps: "all"});

      if ($(window).outerWidth() < 768) {
        day_Push.to($dayAtContent.find('.time-push-wrapper[data-time="' + prevTime + '"]'), 0.75, {
          x: $dayAtContent.outerWidth(),                                                                         // hide the ones we don't want
          ease: Back.easeInOut,
          force3D: false,
          onComplete: function () {
            $dayAtContent.find('.time-push-wrapper[data-time="' + prevTime + '"]').each(function () {
              $(this).removeClass('active').removeAttr('style');
            });
          }
        });

        day_Push.staggerFrom($dayAtContent.find('.time-push-wrapper[data-time="' + time + '"]'), 0.75, {
          x: $dayAtContent.outerWidth(),
          ease: Back.easeInOut,
          force3D: false,
          onStart: function () {
            $dayAtContent.find('.time-push-wrapper[data-time="' + time + '"]').addClass('active');
          },
          onComplete: function () {
            $dayAtContent.removeAttr('style');
          }
        }, 0.3);
      } else {
        day_Push.to($dayAtContent.find('.time-push-wrapper[data-time="' + prevTime + '"]'), 0.75, {
          y: contentH,                                                                         // hide the ones we don't want
          ease: Expo.easeInOut,
          force3D: false,
          onComplete: function () {
            $dayAtContent.find('.time-push-wrapper[data-time="' + prevTime + '"]').each(function () {
              $(this).removeClass('active').removeAttr('style');
            });
          }
        });

        day_Push.staggerFrom($dayAtContent.find('.time-push-wrapper[data-time="' + time + '"]'), 0.75, {
          y: contentH,
          ease: Expo.easeInOut,
          force3D: false,
          onStart: function () {
            $dayAtContent.find('.time-push-wrapper[data-time="' + time + '"]').addClass('active');
          },
          onComplete: function () {
            $dayAtContent.removeAttr('style');
          }
        }, 0.3);
      }

    });

    $(window).on('resize', function () {
      if ($(window).outerWidth() > 768) {
        setTimeout(function () {
          $dayAtNav.find('a').each(function () {
            if ($(this).attr('data-medium-text') !== $(this).text()) {
              var resizeText = $(this).attr('data-medium-text');
              $(this).text(resizeText);
            }
          });

          $dayAtContent.find('img').each(function () {
            if ($(this).attr('data-big-src') !== $(this).attr('src')) {
              var resizeImage = $(this).attr('data-big-src');
              $(this).attr('src', resizeImage);
            }
          });
        }, 100);
      } else {
        setTimeout(function () {
          $dayAtNav.find('a').each(function () {
            if ($(this).attr('data-mobile-text') !== $(this).text()) {
              var resizeText = $(this).attr('data-mobile-text');
              $(this).text(resizeText);
            }
          });

          $dayAtContent.find('img').each(function () {
            if ($(this).attr('data-mobile-src') !== $(this).attr('src')) {
              var resizeImage = $(this).attr('data-mobile-src');
              $(this).attr('src', resizeImage);
            }
          });
        }, 100);
      }

      setTimeout(function () {
        var leftPos, newWidth,
         $dayAtNav = $('.day-at-nav'),
         $magicLine = $dayAtNav.find('.magic-line');

        $magicLine.width($dayAtNav.find('.active a').width()).css("left", $dayAtNav.find('.active a').position().left);

      }, 100);

    });
  });

  //iFB Help Desk
  $('.hd-trigger').on('click', function (e) {
    e.preventDefault();
    $('.help-desk-info').slideDown(1000, function(){
      $('.help-desk-info').focus();
    });
  });

  $('.help-desk-info .big-close-button').on('click', function (e) {
    e.preventDefault();
    $('.help-desk-info').slideUp(500, function(){
      $('.hd-trigger').focus();
    });
  });

  $('.rotating-push').slick({
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    focusOnChange: true, 
    accessibility: true, 
    responsive: [{
      breakpoint: 1201,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        touchThreshold: 100
      }
    }, {
      breakpoint: 1025,
      settings: {
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        touchThreshold: 100
      }
    }, {
      breakpoint: 640,
      settings: {
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        touchThreshold: 100
      }
    }, {
      breakpoint: 480,
      settings: {
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });

  $('.rotating-push-wrapper').on('click', '.slick-prev', function (e) {
    e.preventDefault();
    $('.rotating-push').slick('slickPrev');
  });

  $('.rotating-push-wrapper').on('click', '.slick-next', function (e) {
    e.preventDefault();
    $('.rotating-push').slick('slickNext');
  });

  //ifb category pushes
  $('.cats-push-wrapper').each(function () {
    var $el = $(this),
     leftPos, newWidth,
     $catNav = $el.find('.push-cats'),
     $catContent = $el.find('.rotating-push-ifb'),
     range = 'dine',
     slickOptions = {
       dots: true,
       infinite: true,
       slidesToShow: 3,
       slidesToScroll: 1,
       focusOnChange: true,
       accessibility: true,
       arrows: false,
       responsive: [{
         breakpoint: 1026,
         settings: {
           dots: true,
           slidesToShow: 3,
           slidesToScroll: 1,
           slickGoTo: 1
         }
       }, {
         breakpoint: 769,
         settings: {
           dots: true,
           slidesToShow: 2,
           slidesToScroll: 1,
           slickGoTo: 1
         }
       }, {
         breakpoint: 640,
         settings: {
           dots: true,
           slidesToShow: 1,
           slidesToScroll: 1,
           slickGoTo: 1
         }
       }]
     };

    $catNav.find('#' + range).addClass('active');
    $catContent.find('.rotating-push-wrapper-ifb[data-category="' + range + '"]').addClass('active');
    if ($(window).outerWidth() <= 1025)
      $('.rotating-push-wrapper-ifb[data-category="' + range + '"]').slick(slickOptions);

    $('.push-cats').on('click', 'a', function (e) {
      e.preventDefault();
      var $trigger = $(this),
       cat = $(this).parent().attr('id'),
       prevCat = $catNav.find('.active').attr('id'),
       contentH = $catContent.outerHeight();

      $catContent.css('height', contentH);

      $catNav.find('li').each(function () {
        $(this).removeClass('active');
      });

      $trigger.parent().addClass('active');

      var cat_Push = new TimelineLite({overwrite: 'all'});

      cat_Push.set($catContent.find('.rotating-push-wrapper-ifb'), {clearProps: "all"});

      if ($(window).outerWidth() <= 1025) {
        cat_Push.to($catContent.find('.rotating-push-wrapper-ifb[data-category="' + prevCat + '"]'), 0.75, {
          x: $catContent.outerWidth(), // hide the ones we don't want
          ease: Back.easeInOut,
          force3D: false,
          onComplete: function () {
            $catContent.find('.rotating-push-wrapper-ifb[data-category="' + prevCat + '"]').each(function () {
              $(this).removeClass('active').removeAttr('style');
            });
          }
        });

        cat_Push.from($catContent.find('.rotating-push-wrapper-ifb[data-category="' + cat + '"]'), 0.75, {
          x: $catContent.outerWidth(),
          ease: Back.easeInOut,
          force3D: false,
          onStart: function () {
            $catContent.find('.rotating-push-wrapper-ifb[data-category="' + cat + '"]').addClass('active');
            $catContent.find('.rotating-push-wrapper-ifb[data-category="' + cat + '"]').slick(slickOptions);
          },
          onComplete: function () {
            $catContent.removeAttr('style');
          }
        }, 0.3);
      } else {
        cat_Push.to($catContent.find('.rotating-push-wrapper-ifb[data-category="' + prevCat + '"]'), 0.75, {
          y: contentH, // hide the ones we don't want
          ease: Expo.easeInOut,
          force3D: false,
          onComplete: function () {
            $catContent.find('.rotating-push-wrapper-ifb[data-category="' + prevCat + '"]').each(function () {
              $(this).removeClass('active').removeAttr('style');
            });
          }
        });

        cat_Push.staggerFrom($catContent.find('.rotating-push-wrapper-ifb[data-category="' + cat + '"]').children('.push-item-wrapper'), 0.75, {
          y: contentH,
          ease: Expo.easeInOut,
          force3D: false,
          onStart: function () {
            $catContent.find('.rotating-push-wrapper-ifb[data-category="' + cat + '"]').addClass('active');
          },
          onComplete: function () {
            $catContent.removeAttr('style');
          }
        }, 0.3);
      }

    });

    $(window).on('resize', function () {
      if ($(window).outerWidth() > 768) {
        setTimeout(function () {
          $catNav.find('a').each(function () {
            if ($(this).attr('data-medium-text') !== $(this).text()) {
              var resizeText = $(this).attr('data-medium-text');
              $(this).text(resizeText);
            }
          });

          $catContent.find('img').each(function () {
            if ($(this).attr('data-big-src') !== $(this).attr('src')) {
              var resizeImage = $(this).attr('data-big-src');
              $(this).attr('src', resizeImage);
            }
          });
        }, 100);
      } else {
        setTimeout(function () {
          $catNav.find('a').each(function () {
            if ($(this).attr('data-mobile-text') !== $(this).text()) {
              var resizeText = $(this).attr('data-mobile-text');
              $(this).text(resizeText);
            }
          });

          $catContent.find('img').each(function () {
            if ($(this).attr('data-mobile-src') !== $(this).attr('src')) {
              var resizeImage = $(this).attr('data-mobile-src');
              $(this).attr('src', resizeImage);
            }
          });
        }, 100);
      }
    });
  });

  $('.home, .nightlife-interior, .spa, .wedding-video, .media-table, .interior, .inset-video').on('click', '.video-overlay a, .press-video', function (e) {
    e.preventDefault();
    var videoURL = "" + $(this).attr('href'),
     embedCode = videoEmbed({url: videoURL, autoplay: 1});
    if ($('#lightbox').length > 0)
      $('#lightbox').find('.lightbox-content .flex-video').html(embedCode);
    else
      $('body').append('<div id="lightbox" class="lightbox" role="dialog" aria-modal="true" tabindex="0"><div class="lightbox-content-wrapper"><div class="lightbox-content" role="document" tabindex="0"><div class="flex-video widescreen">' + embedCode + '</div></div></div><a class="close-button big-close-button" title="Close Button" tabindex="1"><span></span></a></div>');

    var trigger = $(this);
    var dialog = $('#lightbox.active');
    var tabbableElements = $('body > *:not(dialog)');

    $('#lightbox').addClass('active');
    $('.lightbox-content').focus();

    disableTabbingOnPage(tabbableElements);

    $('#lightbox').on('click', '.close-button', function (e) {
      e.preventDefault();
      $(this).closest('#lightbox').removeClass('active');
      $('#lightbox').find('.flex-video').html('');
    });


    // Close lightbox when escape key is pressed
    $(document).keyup(function(e) {
      if ( $('.lightbox').hasClass('active') ) {
        if (e.which == 27) {  // needed to make lightbox  only close by esc button
          if($(e.target).hasClass('lightbox') || $(e.target).parents().has('lightbox')) {
            $('.lightbox .close-button').trigger('click');
            $(this).closest('#lightbox').removeClass('active');
            $('#lightbox').find('.flex-video').html('');
            reEnableTabbingOnPage(tabbableElements);
            $(trigger).focus();
          }
        } 
      }
    });

    // Close lightbox when enter key is pressed
    $('.lightbox .close-button').keypress(function(e) {
      var key = e.which;
      if ( $('.lightbox').hasClass('active') ) {
        if(key == 13) {
          if($(e.target).hasClass('lightbox') || $(e.target).parents().has('lightbox')) {
            $('.lightbox .close-button').trigger('click');
            $(this).closest('#lightbox').removeClass('active');
            $('#lightbox').find('.flex-video').html('');
            reEnableTabbingOnPage(tabbableElements);
            $(trigger).focus();
          }
          return false;  
        }
      }
    });
  });

  function disableTabbingOnPage(tabbableElements) {  
    $.each(tabbableElements, function (index, element) {
      $(element).attr('tabindex', '-1');
    })
  }

  function reEnableTabbingOnPage(tabbableElements) {
    $.each(tabbableElements, function (index, element) {
      $(element).attr('tabindex', '0');
    })
  }

  $('.video-inset').on('click', ' a', function (e) {
    e.preventDefault();
    var $el = $(this),
     videoURL = "" + $el.attr('href'),
     embedCode = videoEmbed({
       url: videoURL,
       autoplay: 1
     });

    TweenLite.to($el, 0.25, {
      opacity: 0, ease: Power3.easeOut,               // close the console selector
      onComplete: function () {
        $el.parent().addClass('flex-video');
        $el.parent().html(embedCode);
      }
    });
  });

  $('.meeting-rooms').on('click', '.meeting-room-inset a', function (e) {
    e.preventDefault();
    var imageURL = $(this).attr('href');

    $('body').append('<div id="lightbox"><div class="lightbox-content-wrapper"><div class="lightbox-content"><img src="' + imageURL + '" /></div></div><a class="close-button big-close-button" title="Close Button"><span></span></a></div>');

    $('#lightbox').addClass('active');

    $('#lightbox').on('click', '.close-button', function (e) {
      e.preventDefault();
      $(this).closest('#lightbox').removeClass('active');
      $('body').find("#lightbox").remove();
    });
  });

  $(window).on('resize', function () {
    setTimeout(function () {
      $('img').each(function () {
        if ($(window).outerWidth() >= 768) {
          if ($(this).attr('src') != $(this).attr('data-big-src'))
            $(this).attr('src', $(this).attr('data-big-src'));
        }
        else {
          if ($(this).attr('src') != $(this).attr('data-mobile-src'))
            $(this).attr('src', $(this).attr('data-mobile-src'));
        }
      });

      $('.smaller-pushes').each(function () {
        if ($(window).outerWidth() > 1024) {
          $(this).height($('.big-push').outerHeight());
          $(this).find('.push-content').removeAttr('style');
        } else if ($(window).outerWidth() <= 1024 && $(window).outerWidth() >= 768) {
          if ($(this).css('height') != 'auto' && $(this).attr('style'))
            $(this).css('height', 'auto');
          $(this).find('.push-content').height($(this).find('.push-image').outerHeight());
        } else {
          if ($(this).css('height') != 'auto' && $(this).attr('style'))
            $(this).css('height', 'auto');
        }
      });

      $('[data-mobile-text]').each(function () {
        if ($(window).outerWidth() >= 768) {
          if ($(this).text() != $(this).attr('data-big-src') && $(this).attr('data-text'))
            $(this).text($(this).attr('data-text'));
        }
        else {
          if ($(this).text() != $(this).attr('data-mobile-text') && $(this).attr('data-mobile-text'))
            $(this).text($(this).attr('data-mobile-text'));
        }
      });
    }, 100);
  });

  window.addEventListener("orientationchange", function () {
    $('.smaller-pushes').each(function () {
      if ($(window).outerWidth() > 1024) {
        $(this).height($('.big-push').outerHeight());
        $(this).find('.push-content').removeAttr('style');
      } else if ($(window).outerWidth() <= 1024 && $(window).outerWidth() >= 768) {
        if ($(this).css('height') != 'auto' && $(this).attr('style'))
          $(this).css('height', 'auto');
        $(this).find('.push-content').height($(this).find('.push-image').outerHeight());
      } else {
        if ($(this).css('height') != 'auto' && $(this).attr('style'))
          $(this).css('height', 'auto');
      }
    });
  }, false);

  if ($('body').hasClass('hakkasan') || $('body').hasClass('la-cote') || $('body').hasClass('scarpetta') || $('body').hasClass('michael-mina') || $('body').hasClass('stripsteak')) {
    var instagramUser = '1371989156';
    var twitterName = 'dinebleau';
    var twitterLinkColor = "#ffffff";
    var igURL = "https://api.instagram.com/v1/users/" + instagramUser + "/media/recent/?access_token=1371989156.1677ed0.573aa0babaf5475a960a08e2a7bec04b";
  } else if ($('body').hasClass('liv')) {
    var instagramUser = '174136585';
    var twitterName = 'Fontainebleau';
    var twitterLinkColor = "#3ABAC3";
    var igURL = "https://api.instagram.com/v1/users/" + instagramUser + "/media/recent/?access_token=174136585.1677ed0.9f281dbbb5a344ee92204ed94b0582ab";
  } else {
    var instagramUser = '174136585';
    var twitterName = 'Fontainebleau';
    var twitterLinkColor = "#3ABAC3";
    var igURL = "https://api.instagram.com/v1/users/" + instagramUser + "/media/recent/?access_token=174136585.1677ed0.d2da36f4257f4098ba12691e3f509173";
  }
  //174136585.1677ed0.19d50907002a474a8158f480a688928a


  // INSTAGRAM
  /*$('.instagram-feed').each(function () {
    var $el = $(this);
    $.ajax({
      type: "GET",
      dataType: "jsonp",
      url: igURL,
      cache: false
    })
     .done(function (response) {
       var p = 0;
       var human_count = 1;
       $.each(response.data, function (i, photo) {
         if (p <= 3 && photo.type == 'image') {
           $el.find('#instagram').append('<div class="column small-6 large-3 image"><a href="' + photo.link + '" target="_blank"><img src="' + photo.images.low_resolution.url + '" alt="Instagram Item '+human_count+'" /></a></div>');
           p++;
           human_count ++;
         }
       });
     });
  });*/ // instagram


  // TWITTER
  $('#twitter-timeline-wrapper').each(function () {
    var limit = 2;
    /*if ($(window).outerWidth() < 1024) {
      $('#twitter-timeline-wrapper').attr('data-limit', '2');
    } else*/ if ($(window).outerWidth() >= 768 && $(window).outerWidth() <= 1024) {
      limit = 3;
      $('#twitter-timeline-wrapper').attr('data-limit', '3');
    } else {
      limit = 1;
      $('#twitter-timeline-wrapper').attr('data-limit', '1');
    }

    twttr.ready(function (twttr) {
      twttr.widgets.createTimeline(
       '583523089444536320',
       document.getElementById('twitter-timeline-wrapper'),
       {
         width: '100%',
         height: 'auto',
         screenName: twitterName,
         showReplies: false,
         chrome: 'nofooter noheader noborders noscrollbar transparent',
         tweetLimit: limit,
         theme: 'dark',
         linkColor: twitterLinkColor,
         related: 'twitterdev,twitterapi'
       }
      );
    });

  }); // twitter

  $(window).on('scroll', function () {
		if ($('body').hasClass('form') && $('#existing-rez-captcha').length > 0) {
			$('.masthead').removeClass('fix');
      $('.wrapper').css('margin-top', 0);
		} else if ($('body').hasClass('interior')) {
      if ($(window).outerWidth() > 1024 && window.pageYOffset > 1) {
        if (!$('.masthead').hasClass('fix')) {
          $('.masthead').addClass('fix');
          $('.wrapper').css('margin-top', $('.wrapper').attr('data-margin-top') + 'px');
        }
      } else {
        $('.masthead').removeClass('fix');
        $('.wrapper').css('margin-top', 0);
      }
    }

    returnToTop();

    setTimeout(function () {
      if ($(window).outerWidth() > 1024) {
        headerHeight = $('.header-wrapper').outerHeight();
        buffer = headerHeight + 100;

				if ($('body').hasClass('ifb-home') && !$('body').hasClass('dining') && !$('body').hasClass('careers')) {
          $('.header-wrapper').addClass('fix');
					$('.booking-console-wrapper').addClass('snapped');
				} else if ($('body').hasClass('home') && !$('body').hasClass('dining') && !$('body').hasClass('careers')) {
          if (!$('.header-wrapper').hasClass('free-floating') && window.pageYOffset > headerHeight) {
            $('.header-wrapper').addClass('free-floating');
          } else if (!$('.header-wrapper').hasClass('fix') && window.pageYOffset > buffer) {
            $('.header-wrapper').removeClass('free-floating').addClass('fix');
          } else if (($('.header-wrapper').hasClass('fix') && !$('.header-wrapper').hasClass('free-floating')) && window.pageYOffset <= buffer) {
            $('.header-wrapper').removeClass('fix').addClass('free-floating');
          } else if (($('.header-wrapper').hasClass('fix') || $('.header-wrapper').hasClass('free-floating')) && window.pageYOffset <= headerHeight) {
            $('.header-wrapper').removeClass('fix').removeClass('free-floating');
          }

          if (window.pageYOffset > (Math.ceil(consoleOffset - headerHeight))) {
            if (!$('body').hasClass('home-dining') && !$('body').hasClass('spa') && !$('body').hasClass('home-careers')) {
              $('.booking-console-wrapper').next().css('border-top', $('.booking-console-wrapper .console-picker').outerHeight() + 'px solid #1e1e1e');
            }
            $('.mastheads').addClass('stay');
            $('.booking-console-wrapper').addClass('snapped');
            $('.header-wrapper').removeClass('no-border');
          } else if ($('.booking-console-wrapper').hasClass('snapped') && window.pageYOffset <= (Math.ceil(consoleOffset - headerHeight))) {
            $('.mastheads').removeClass('stay');
            $('.booking-console-wrapper').removeClass('snapped');
            $('.booking-console-wrapper').next().removeAttr('style');
          }
        } else {
          $('.header-wrapper').addClass('fix');
        }
      }
    }, 50);
  });

  $(window).on('resize', function () {
    var tweetLimit = $('#twitter-timeline-wrapper').attr('data-limit');
    setTimeout(function () {
      if ($(window).outerWidth() <= 1024) {
        $('.header-wrapper').removeClass('free-floating');
        $('.header-wrapper').removeClass('fix');
        $('.booking-console-wrapper').removeClass('snapped').removeAttr('style');
      }

      $('#twitter-timeline-wrapper').each(function () {
        var limit = 2;
        /*if ($(window).outerWidth() < 768) {
          $('#twitter-timeline-wrapper').attr('data-limit', '1');
        } else*/ if ($(window).outerWidth() >= 768 && $(window).outerWidth() <= 1024) {
          limit = 3;
          $('#twitter-timeline-wrapper').attr('data-limit', '3');
        } else {
          limit = 1;
          $('#twitter-timeline-wrapper').attr('data-limit', '2');
        }

        if (limit != tweetLimit) {
          $('#twitter-timeline-wrapper').html('');

          twttr.widgets.createTimeline(
           '583523089444536320',
           document.getElementById('twitter-timeline-wrapper'),
           {
             width: '100%',
             height: 'auto',
             screenName: 'Fontainebleau',
             showReplies: false,
             chrome: 'nofooter noheader noborders noscrollbar transparent',
             tweetLimit: limit,
             theme: 'dark',
             linkColor: '#3ABAC3',
             related: 'twitterdev,twitterapi'
           }
          );
        }
      });
    }, 100);
  });

  $('.explore-more').on('click', function (e) {
    e.preventDefault();

    var $elem = $(this);
    if ($elem.parent().hasClass('active')) {
      $elem.parent().removeClass('active');
    } else {
      $elem.parent().addClass('active');
    }
  });

  $('#return-to-top').on('click', function (e) {
    e.preventDefault();
    $('body,html').animate({
      scrollTop: 0
    }, 500);
  });

  $('.home-dining-content').each(function () {
    var $el = $(this),
     $catNav = $el.find('.dining-nav'),
     $catContent = $el.find('.home-dining-wrapper'),
     cat = 'menu';

    $catNav.find('#' + cat).addClass('active');
    $catContent.find('.row[data-cat="' + cat + '"]').each(function () {
      $(this).addClass('active');
    });

    $('.dining-nav').on('click', 'a', function (e) {
      e.preventDefault();
      var $trigger = $(this),
       cat = $(this).parent().attr('id');

      //console.log(cat);
      $catNav.find('li').each(function () {
        $(this).removeClass('active');
      });

      $catContent.find('.row').each(function () {
        $(this).removeClass('active');
      });

      $trigger.parent().addClass('active');
      $catContent.find('.row[data-cat="' + cat + '"]').each(function () {
        $(this).addClass('active');
      });
    });
  });


  $('body.home .video-push').each(function () {
    var today = new Date().getTime(),
     startDate1 = new Date("Nov 22 2016 00:00:00").getTime(),
     endDate1 = new Date("Jan 1 2017 00:00:00").getTime();

    if (today > startDate1 && today < endDate1) {

    } else if (today > endDate1) {
      $(this).hide();
      $('.grid-pushes').removeClass('hide');
    }
  });

  // $('.upcoming-events .up-wrapper').each(function () {
  //   var $wrap = $(this);

  //   if ($wrap.find('.up-event').length > 1) {
  //     $wrap.slick({
  //       centerMode: true,
  //       centerPadding: '200px',
  //       dots: false,
  //       infinite: true,
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       arrows: true,
  //       accessibility: true,
  //       slide: '.up-event',
  //       responsive: [{
  //         breakpoint: 1250,
  //         settings: {
  //           centerPadding: '100px'
  //         }
  //       }, {
  //         breakpoint: 1025,
  //         settings: {
  //           centerMode: false
  //         }
  //       }]
  //     });
  //   }
  // });

  $('.up-wrapper').slick({
    centerMode: true,
    centerPadding: '200px',
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    // slide: '.up-wrapper',
    arrows: true,
    focusOnChange: true,
    accessibility: true,
    responsive: [{
      breakpoint: 1201,
      settings: {
        centerPadding: '100px'
      }
    }, {
      breakpoint: 1025,
      settings: {
        centerMode: false
      }
    }]
  });

  $('.past-performances .pp-wrapper').slick({
    dots: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    accessibility: true,
    responsive: [{
      breakpoint: 1201,
      settings: {
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true
      }
    }, {
      breakpoint: 1025,
      settings: {
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true
      }
    }, {
      breakpoint: 769,
      settings: {
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }, {
      breakpoint: 640,
      settings: {
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }, {
      breakpoint: 480,
      settings: {
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }]
  });

  $('.myfb .masthead-push-wrapper').slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    accessibility: true
  });


  // Reservation Forms Tabs
  $('.rez-forms-wrapper').each(function () {
    var $el = $(this),
     $catNav = $el.find('.rez-forms-nav'),
     $catContent = $el.find('.rez-forms'),
     cat = 'existing-rez';

    $catNav.find('#' + cat).addClass('active');
    $catContent.find('.row[data-cat="' + cat + '"]').each(function () {
      $(this).addClass('active');
    });

    $('.rez-forms-nav').on('click', 'a', function (e) {
      e.preventDefault();
      var $trigger = $(this),
       cat = $(this).parent().attr('id');

      //console.log(cat);
      $catNav.find('li').each(function () {
        $(this).removeClass('active');
      });

      $catContent.find('.row').each(function () {
        $(this).removeClass('active');
      });

      $trigger.parent().addClass('active');
      $catContent.find('.row[data-cat="' + cat + '"]').each(function () {
        $(this).addClass('active');
      });

      if ( $('#' + cat + '-captcha').children().length == 0 ) {
        grecaptcha.render(cat + '-captcha', {
          // 'sitekey': '6LdJIVwUAAAAAH-CWaY9_B5oocQgiPk4k4tgd4Nq',
          'sitekey': '6LfsoxAaAAAAAMd5mUHuHr1Kj08BEVt8Qdm1JJA2',
          'theme': 'light'
        });
      }


    });
  });

  // Owners Reservation Request - New Request
  $('#new-rez').each(function () {
    var units = ["20701", "20702", "20703", "20704", "20705", "20707", "20715", "20717", "20816", "20905", "20906", "20915", "21001", "21003", "21006", "21007", "21015", "21017",
      "21104", "21106", "21215", "21217", "21504", "21603", "21614", "21615", "21616", "21617", "21707", "21815", "21902", "21904", "21905", "21907", "22107", "22109", "22111", "22114",
      "22206", "22214", "22215", "22216", "22314", "22315", "22405", "22407", "22415", "22417", "22504", "22505", "22507", "22512", "22515", "22610", "22612", "22614", "22616", "22706",
      "22711", "22801", "22803", "22810", "22812", "23002", "23205", "23207", "23215", "23217", "23308", "23309", "23310", "23312", "23315", "23414", "23506", "23603", "23606", "23608",
      "23610", "23612", "23614", "23616", "23702", "30310", "30403", "30409", "30506", "30507", "30522", "30523", "30602", "30603", "30605", "30609", "30610", "30616", "30618", "30621",
      "30719", "30918", "31003", "31202", "31204", "31213", "31214", "31418", "31601", "31614", "31804", "31905"];
    $('.new-rez-units').on('focusout', function () {
      val = $(this).val();
      // console.log(val);
      // console.log($.inArray(val,units)); /* Returns -1 for false, 0 for true */
      // console.log($(this).val().length);
      valLen = $(this).val().length;
      if (valLen == 5) {
        if ($.inArray(val, units) != -1) {
          $('label[for="arrival-date"]').html('<span class="alert">*</span>Guest Arrival Date <span class="alert">Arrival date must be made at least 5 days out</span>');
          $('#arrival-date').pickadate('picker').set('min', 5);
          $('#departure-date').pickadate('picker').set('min', 5);

        } else {
          $('label[for="arrival-date"]').html('<span class="alert">*</span>Guest Arrival Date');
          $('#arrival-date').pickadate('picker').set('min', 1);
          $('#departure-date').pickadate('picker').set('min', 1);
          $('label[for="unit_numbers"]').html('<span class="alert">*</span>Unit Numbers');
        }
      } else {
        $('label[for="unit_numbers"]').html('<span class="alert">*</span>Unit Numbers <span class="alert">Unit Number must be 5 digits</span>');
        $(this).focus();
      }
    });

    // ARRIVE TIME
    $('#arrival_time').pickatime({
      formatSubmit: 'HH:i:00',
      interval: 15
    });
  });


  // GALLERY ROOT
  function goGallery() {
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid=114',
      showInfo: true
    });
  }
  if (!$('body').hasClass('booking')) { // testing
    $('.primary-nav li#220').on('click', function (e) {
      e.preventDefault();
      goGallery();
    });

    $('.media-gallery').on('click', '.socialize a', function (e) {
      e.preventDefault();
      e.stopPropagation();

      window.open('/social', '_blank');
    });
  }
  if (location.hash === "#goGallery")
    goGallery();
  // gallery root

  //hakkasan photo gallery
  $('.primary-nav li#191, body.home-dining.hakkasan .home-dining-wrapper .gallery-toggle, .primary-nav li#389, .primary-nav li#573').on('click', function (e) {
    e.preventDefault();
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid=73',
      showInfo: true,
      splitCategory: false
    });
  });

  //la cote photo gallery
  $('body.home-dining.la-cote .home-dining-wrapper .gallery-toggle, .primary-nav li#675').on('click', function (e) {
    e.preventDefault();
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid=415',
      showInfo: true,
      splitCategory: false
    });
  });

  //michael mina/pizza burger photo gallery
  $('body.home-dining.pizza-burgers .home-dining-wrapper .gallery-toggle, .primary-nav li#709').on('click', function (e) {
    e.preventDefault();
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid=437',
      showInfo: true,
      splitCategory: false
    });
  });

  // dining/arkadia-grill
  $('body.home-dining.arkadia-grille .home-dining-wrapper .gallery-toggle').on('click', function (e) {
    e.preventDefault();
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid=912',
      showInfo: true,
      splitCategory: false
    });
  });

  //stripsteak
  $('.primary-nav li#223, body.home-dining.stripsteak .home-dining-wrapper .gallery-toggle, .primary-nav li#407, .primary-nav li#583').on('click', function (e) {
    e.preventDefault();
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid=148',
      showInfo: true,
      splitCategory: false
    });
  });

  //michael mina
  $('.primary-nav li#242, body.home-dining.michael-mina .home-dining-wrapper .gallery-toggle, .primary-nav li#589').on('click', function (e) {
    e.preventDefault();
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid=149',
      showInfo: true,
      splitCategory: false
    });
  });

  //scarpetta
  $('.primary-nav li#222, body.home-dining.scarpetta .home-dining-wrapper .gallery-toggle, .primary-nav li#401, .primary-nav li#578').on('click', function (e) {
    e.preventDefault();
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid=150',
      showInfo: true,
      splitCategory: false
    });
  });

  //only at fb gallery
  var onlyFBId = '';
  var onlyFBNavId = '';
  if ( devEnv == 'lh' ) {
    onlyFBId = '859';
    onlyFBNavId = '1040'
  } else if ( devEnv == 'dev' ) {
    onlyFBId = '871';
    onlyFBNavId = '1042';
  } else if ( devEnv == 'cert' ) {
    onlyFBId = '869';
    onlyFBNavId = '1042';
  } else {
    onlyFBId = '866';
    onlyFBNavId = '1050'
  }
  var onlyFBNavItem = $('.primary-nav li#'+onlyFBNavId);
  $(onlyFBNavItem).on('click', function (e) {
    e.preventDefault();
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid='+onlyFBId,
      showInfo: true,
      splitCategory: false
    });
  });

  //begin locker 28 gallery
  var locker28Id = '';
  if ( devEnv == 'lh' ) {
    locker28Id = '856';
  } else if ( devEnv == 'dev' ) {
    locker28Id = '869';
  } else if ( devEnv == 'cert' ) {
    locker28Id = '867';
  } else {
    locker28Id = '863';
  }
  $('body.home-dining.experiences-dining .home-dining-wrapper .menu .gallery-toggle').on('click', function (e) {
    e.preventDefault();
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid='+locker28Id,
      showInfo: true,
      splitCategory: false
    });
  });
  //end locker 28 gallery

  //begin Bleau Fish Waterworld gallery
  var bleauFishId = '';
  if ( devEnv == 'lh' ) {
    bleauFishId = '858';
  } else if ( devEnv == 'dev' ) {
    bleauFishId = '868';
  } else if ( devEnv == 'cert' ) {
    bleauFishId = '866';
  } else {
    bleauFishId = '864';
  }
  $('body.home-dining.experiences-dining .home-dining-wrapper .team .gallery-toggle').on('click', function (e) {
    e.preventDefault();
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid='+bleauFishId,
      showInfo: true,
      splitCategory: false
    });
  });
  //end Bleau Fish Waterworld gallery

  //begin Sapphire Noir gallery
  var sapphireId = '';
  if ( devEnv == 'lh' ) {
    sapphireId = '857';
  } else if ( devEnv == 'dev' ) {
    sapphireId = '870';
  } else if ( devEnv == 'cert' ) {
    sapphireId = '868';
  } else {
    sapphireId = '865';
  }
  $('body.home-dining.experiences-dining .home-dining-wrapper .info .gallery-toggle').on('click', function (e) {
    e.preventDefault();
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid='+sapphireId,
      showInfo: true,
      splitCategory: false
    });
  });
  //end Sapphire Noir gallery


  //myfb
  $('.myfb .footer-nav #util-436').on('click', function (e) {
    e.preventDefault();
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid=153',
      showInfo: true,
      // splitCategory: false
    });
  });


  // ACCOMMODATIONS GALLERY
  function goAccommodations() {
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid=114',
      showInfo: true,
      splitCategory: true,
      showTiles: false,
      startCategory: 'accommodations'
    });
  }
  $('.nav-push .accommodations-gal, .gallery-list .accommodations').on('click', function (e) {
    e.preventDefault();
    goAccommodations();
  });
  if (location.hash === "#goAccommodations")
    goAccommodations();
  // accommodations gallery

  // HOTEL GALLERY
  function goHotel(){
    //console.log('site.js goHotel');
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid=114',
      showInfo: true,
      splitCategory: true,
      showTiles: false,
      startCategory: 'The Hotel'
    });
  }
  $('.gallery-list .hotel').on('click', function (e) {
    e.preventDefault();
    goHotel();
  });
  if (location.hash === "#goHotel")
    goHotel();
  // hotel gallery


  // DINING GALLERY
  function goDining(){
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid=114',
      showInfo: true,
      splitCategory: true,
      showTiles: false,
      startCategory: 'dining'
    });
  }
  $('.nav-push .dining-gal, .gallery-list .dining').on('click', function (e) {
    e.preventDefault();
    goDining();
  });
  if ( location.hash === '#goDining' )
    goDining();
  // dining gallery

  // NIGHTLIFE GALLERY
  function goNightlife() {
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid=114',
      showInfo: true,
      splitCategory: true,
      showTiles: false,
      startCategory: 'Nightlife'
    });
  }
  $('.nav-push .nightlife-gal, .gallery-list .nightlife').on('click', function (e) {
    e.preventDefault();
    goNightlife();
  });
  if( location.hash === '#goNightlife' )
    goNightlife();
  // nightlife gallery

  // SPA (LAPIS) GALLERY
  function goSpa() {
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid=114',
      showInfo: true,
      splitCategory: true,
      showTiles: false,
      startCategory: 'Lapis, The Spa at Fontainebleau'
    });
  }
  $('.nav-push .spa-gal, .gallery-list .spa').on('click', function (e) {
    e.preventDefault();
    goSpa();
  });
  if( location.hash === '#goSpa' )
    goSpa();
  // spa (lapis) gallery

  // ACTIVITIES GALLERY
  function goActivities() {
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid=114',
      showInfo: true,
      splitCategory: true,
      showTiles: false,
      startCategory: 'The Hotel' // default tour
    });
  }
  $('.nav-push .activities-gal').on('click', function (e) {
    e.preventDefault();
    goActivities();
  });
  if ( location.hash === '#goActivities' )
    goActivities();
  // activities gallery

  // MEETINGS GALLERY
  function goMeetings(){
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid=114',
      showInfo: true,
      splitCategory: true,
      showTiles: false,
      startCategory: 'Meetings & Weddings'
    });
  }
  $('.nav-push .meetings-gal, .gallery-list .meetingsevents').on('click', function (e) {
    e.preventDefault();
    goMeetings();
  });
  if ( location.hash === '#goMeetings' || location.hash === '#goWeddings' || location.hash === '#goGatherings' )
    goMeetings();
  // meetings gallery

  //owners gallery
  $('.primary-nav li#359, .secondary-nav li#359').on('click', function (e) {
    e.preventDefault();
    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid=243',
      showInfo: true,
      splitCategory: false
    });
  });

  //ICBE gallery tracking
  $('.nav-220').on('click', function (e) {
    executeTrackingCode();
    $('#gallery').focus();
  });

    // Careers GALLERY
  function goCareers(pageID){

    $('.media-gallery').ballyhoo({
      dataSource: '/ajax/gallery?pageid='+pageID,
      showInfo: true,
      splitCategory: false
    });
  }

  // Careers Gallery
  $('.careers-trigger').on('click', function (e) {
      e.preventDefault();
      let pageID = $(this).attr('href');
      pageID = pageID.replace('/gallery-','');
      goCareers(pageID);
    });

  if ( location.hash === '#goCareers' )
    goCareers();
  // careers gallery


  //dynamic specials for interior pages or dining/spa home pages
  if ($(document.body).hasClass('interior') ||
   $(document.body).hasClass('home-dining') ||
   $(document.body).is('.home.spa')) {
    var pageId = $(document.body).attr('data-pageid');
    var templateId = $(document.body).attr('data-templateid');

    if ('undefined' === typeof (pageId && templateId)) {
      //console.warn('dynamicspecials: not running, need pageId and templateId');
    } else {
      var isHome = document.body.className.indexOf('home') !== -1;

      (function () {
        var specialsUrl = '/ajax/getdynamicspecials?pageid=' + pageId + '&templateid=' + templateId;
        var templateUrl = '/templates/main/js/templates/dynamic-push-templates.html';
        var getSpecials = $.ajax(specialsUrl);
        var getTemplates = $.ajax({url: templateUrl, cache: true});

        $.when(getTemplates, getSpecials)
         .done(onSuccess)
         .fail(onFailure);

        function onFailure(response) {
          // console.error('dynamicspecials: could not get data', response);
        }

        function onSuccess(templateData, specialData) {
          // the two arguments are arrays, eg. [data, textStatus, jqXHR]
          var specials = specialData[0];

          if (specials.data['@attributes'].success !== "1" || $.isEmptyObject(specials.data.data)) {
            // console.warn('dynamicspecials: data was unsuccessful', specials.data.errors);
            return false;
          }

          var $templates = $(templateData[0]);
          var sidePushTemplate = Handlebars.compile($templates.filter('#side-pushes').html());
          var bottomHomeTemplate = Handlebars.compile($templates.filter('#bottom-home-pushes').html());
          var bottomInteriorTemplate = Handlebars.compile($templates.filter('#bottom-interior-pushes').html());
          var specialRecords = specials.data.data.record;

          if (!isArray(specialRecords)) specialRecords = [specialRecords];

          $.each(specialRecords, function (i, record) {
            var id = record['@attributes'].id;

            if (!isArray(record.content.record)) record.content.record = [record.content.record];

            if (id === 'right_push_marketing') {
              //replacePush('.side-push-wrapper .hover-push', sidePushTemplate(record.content.record));
            } else if (id === 'bottom-push-marketing') {
              replacePush('.bottom-interior-pushes .push-item', bottomInteriorTemplate(record.content.record));
            } else if ((id === 'push-marketing' && isHome) || id === 'push-marketing-area-2') {
              replacePush('.dining-monthly-wrapper .dining-push-wrapper', bottomHomeTemplate(record.content.record));
            }
          });
        }

        // pass in the selector for each push item for the rawHTML to replace
        function replacePush(selector, rawHTML) {
          var $pushes = $(selector);
          $pushes.last().after(rawHTML);
          $pushes.remove();
        }
      }());
    }
  }

  //media library
  $('.media-library').on('click', '.img-lightbox', function (e) {
    e.preventDefault();
    var imageURL = $(this).attr('href');

    $('body').append('<div id="lightbox"><div class="lightbox-content-wrapper"><div class="lightbox-content"><img src="' + imageURL + '" /></div></div><a class="close-button big-close-button" title="Close Button"><span></span></a></div>');

    $('#lightbox').addClass('active');

    $('#lightbox').on('click', '.close-button', function (e) {
      e.preventDefault();
      $(this).closest('#lightbox').removeClass('active');
      $('body').find("#lightbox").remove();
    });
  });

  $('.media-library').on('click', '.download-link', function (e) {
    e.preventDefault();
    var imageURL = $(this).attr('href');

    $('body').append('<div id="lightbox" class="lightbox media-lib-lightbox" data-img="' + imageURL + '" role="dialog" aria-modal="true" tabindex="0"><div class="lightbox-content-wrapper"><div class="lightbox-content" role="document" tabindex="0"><div class="lightbox-form-wrapper"><h2>Welcome to Fontainebleau Media Library</h2><div class="row"><form method="post" class="standard validate small-12 column" id="media-lib"><p>(<span class="alert">*</span>) <em>required field</em></p><fieldset><div class="field small-12 medium-6 columns"><label for="first_name"><span class="alert">*</span>First Name</label><input type="text" name="first_name" id="first_name" maxlength="100" class="textfield required" required="required"  placeholder="First Name" value="" /></div><div class="field small-12 medium-6 columns"><label for="last_name"><span class="alert">*</span>Last Name</label><input type="text" name="last_name" id="last_name" maxlength="100" class="textfield required" required="required"  placeholder="Last Name" value="" /></div><div class="field small-12 medium-6 columns"><label for="email"><span class="alert">*</span>Email Address</label><input type="text" name="email" id="email" maxlength="100" class="large email textfield required" required="required"  placeholder="Email Address" value="" /></div><div class="field small-12 medium-6 columns"><label for="phone">Phone Number (optional)</label><input type="text" name="phone" id="phone" maxlength="15" class="textfield" placeholder="Phone Number" /></div><div class="field small-12 columns"><ul class="checkboxgroup" id="checkbox-terms"><li><input type="checkbox" name="terms" id="terms" value="1" required="required" /><label for="terms"><span class="alert">*</span> I agree to the terms and conditions of the press room.</label></li></ul></div><div class="field"><button class="progress-button submit"><span class="button-content">Get Download Link</span><span class="button-progress"><i class="fa fa-cog fa-spin"></i></span></button></div></fieldset></form></div></div></div></div><a class="close-button big-close-button" title="Close Button" tabindex="1"><span></span></a></div>');

    var trigger = $(this);
    var dialog = $('#lightbox.active');
    var tabbableElements = $('body > *:not(dialog)');

    $('#lightbox').addClass('active');
    $('.lightbox-content').focus();

    disableTabbingOnPage(tabbableElements);

    $('#lightbox').on('click', '.close-button', function (e) {
      e.preventDefault();
      $(this).closest('#lightbox').removeClass('active');
      $('body').find("#lightbox").remove();
    });

    // Close lightbox when escape key is pressed
    $(document).keyup(function(e) {
      if ( $('.lightbox').hasClass('active') ) {
        if (e.which == 27) {  // needed to make lightbox  only close by esc button
          if($(e.target).hasClass('lightbox') || $(e.target).parents().has('lightbox')) {
            $('.lightbox .close-button').trigger('click');
            $(this).closest('#lightbox').removeClass('active');
            $('body').find("#lightbox").remove();
            reEnableTabbingOnPage(tabbableElements);
            $(trigger).focus();
          }
        } 
      }
    });

    // Close lightbox when enter key is pressed
    $('.lightbox .close-button').keypress(function(e) {
      var key = e.which;
      if ( $('.lightbox').hasClass('active') ) {
        if(key == 13) {
          if($(e.target).hasClass('lightbox') || $(e.target).parents().has('lightbox')) {
            $('.lightbox .close-button').trigger('click');
            $(this).closest('#lightbox').removeClass('active');
            $('body').find("#lightbox").remove();
            reEnableTabbingOnPage(tabbableElements);
            $(trigger).focus();
          }
          return false;  
        }
      }
    });
  });

  function disableTabbingOnPage(tabbableElements) {  
    $.each(tabbableElements, function (index, element) {
      $(element).attr('tabindex', '-1');
    })
  }

  function reEnableTabbingOnPage(tabbableElements) {
    $.each(tabbableElements, function (index, element) {
      $(element).attr('tabindex', '0');
    })
  }

  $('body').on('click', '.alert-box .close', function (e) {
    e.preventDefault();
    $(this).closest('.shown').removeClass('shown');
  });

  $('body').on('click', '#media-lib .submit', function (e) {
    e.preventDefault();

    var $el = $(this),
     $form = $el.closest('form'),
     imageURL = $el.closest('#lightbox').attr('data-img'),
     formValues = $form.serialize(),
     $lightboxContent = $el.closest('.lightbox-content');

    //console.log(formValues);
    $form.parsley().validate();

    if ($form.parsley().isValid()) {
      $el.addClass('loading').attr('disabled', 'disabled');

      $form.find('input, textarea').each(function () {
        $(this).attr('disabled', 'disabled');
      });

      $.ajax({
        type: "POST",
        url: "/ajax/processmedialibrary?" + formValues,
        success: function (response) {
          var errors = response.data.errors.record;

          if (jQuery.isEmptyObject(response.data.errors)) {

            $lightboxContent.html('<div class="lightbox-form-wrapper text-center"><h2>Thank You!</h2><p>Thank You! Click the button below for access to the high-res image</p><p><a href="' + imageURL + '" class="button inverse-button pink-button" target="_blank">Download Image</a></p></div>').css('overflow', 'hidden');

            $el.removeClass('loading').addClass('state-success');

            setTimeout(function () {
              $el.removeClass('state-success').removeAttr('disabled');

              $('#lightbox').addClass('active');
              $('html, body').css('overflow', 'hidden');

              $form.find('input, textarea').each(function () {
                $(this).val('').removeAttr('disabled');
              });

              $form.closest('.console').closeConsole();
              $('.spa-inline').children('.column').removeClass('active');

            }, 1000);

            $('#lightbox').on('click', '.close-button', function (e) {
              e.preventDefault();
              $(this).closest('#lightbox').removeClass('active');
              $('html,body').removeAttr('style').find("#lightbox").remove();
            });

          } else {
            var $listErrors = $('<ul />');
            $.each(errors, function (i, error) {
              var errorMessage = $('<li />').text(error.message);
              $listErrors.append(errorMessage);
            });

            $lightboxContent.find('#media-lib').prepend('<p>Could not process form, please check that the fields are filled out correctly and try again.</p><ul>' + $listErrors.html() + '</ul>');

            $el.removeClass('loading').addClass('state-error');

            setTimeout(function () {
              $el.removeClass('state-error');

              $('#lightbox').addClass('active');
              $('html, body').css('overflow', 'hidden');

              $form.find('input, textarea').each(function () {
                $(this).removeAttr('disabled');
              });

            }, 1000);

            $('#lightbox').on('click', '.close-button', function (e) {
              e.preventDefault();
              $(this).closest('#lightbox').removeClass('active');
              $('html,body').removeAttr('style').find("#lightbox").remove();
            });
          }

        }
      });
    }
  });

  var fullDate = new Date();
  var twoDigitMonth = ((fullDate.getMonth().length + 1) === 1) ? (fullDate.getMonth() + 1) : '0' + (fullDate.getMonth() + 1);
  var twoDigitDay = ((fullDate.getDate().length + 1) === 1) ? (fullDate.getDate()) : '0' + (fullDate.getDate());
  var currentDate = twoDigitMonth + "/" + twoDigitDay + "/" + fullDate.getFullYear();
  $('.new-rez #todays_date').val(currentDate);

  // cabanas lightbox
  $('.cabanas-list').on('click', '.lightbox-trigger', function (e) {
    e.preventDefault();
    var imageURL = $(this).attr('href');

    $('body').append('<div id="lightbox" class="lightbox" role="dialog" aria-modal="true" tabindex="0"><div class="lightbox-content-wrapper"><div class="lightbox-content" role="document" tabindex="0"><img src="' + imageURL + '" /></div></div><a class="close-button big-close-button" title="Close Button" tabindex="1"><span></span></a></div>');

    var trigger = $(this);
    var dialog = $('#lightbox.active');
    var tabbableElements = $('body > *:not(dialog)');

    $('#lightbox').addClass('active');
    $('.lightbox-content').focus();

   disableTabbingOnPage(tabbableElements);

    $('#lightbox').on('click', '.close-button', function (e) {
      e.preventDefault();
      $(this).closest('#lightbox').removeClass('active');
      $('body').find("#lightbox").remove();
      reEnableTabbingOnPage(tabbableElements);
      $(trigger).focus();
    });

    // Close lightbox when escape key is pressed
    $(document).keyup(function(e) {
      if ( $('.lightbox').hasClass('active') ) {
        if (e.which == 27) {  // needed to make lightbox  only close by esc button
          if($(e.target).hasClass('lightbox') || $(e.target).parents().has('lightbox')) {
            $('.lightbox .close-button').trigger('click');
            $(this).closest('#lightbox').removeClass('active');
            $('body').find("#lightbox").remove();
            reEnableTabbingOnPage(tabbableElements);
            $(trigger).focus();
          }
        } 
      }
    });

    // Close lightbox when enter key is pressed
    $('.lightbox .close-button').keypress(function(e) {
      var key = e.which;
      if ( $('.lightbox').hasClass('active') ) {
        if(key == 13) {
          if($(e.target).hasClass('lightbox') || $(e.target).parents().has('lightbox')) {
            $('.lightbox .close-button').trigger('click');
            $(this).closest('#lightbox').removeClass('active');
            $('body').find("#lightbox").remove();
            reEnableTabbingOnPage(tabbableElements);
            $(trigger).focus();
          }
          return false;  
        }
      }
    });
  });

  function disableTabbingOnPage(tabbableElements) {  
    $.each(tabbableElements, function (index, element) {
      $(element).attr('tabindex', '-1');
    })
  }

  function reEnableTabbingOnPage(tabbableElements) {
    $.each(tabbableElements, function (index, element) {
      $(element).attr('tabindex', '0');
    })
  }

  // misc tracking events/conversions. trackAsConversion fn is in helpful-functions.js
  // special offers book now buttons
  $('.package-wrapper .book-now').on('click', trackAsConversion);


  // Summer Countdown
  var pageURL = window.location.href.split(".com/");
  pageURL = pageURL[1];
  if (pageURL === 'summer') {
    var contentDiv = $('.content-wrapper .content:first-of-type');
    var ctas = $('.content-wrapper').find('a.button');
    var now = new Date();

    // convert to UTC equivalent of EST
    // 11/25/2015 12:01 AM
    var start = new Date(Date.UTC(2016, 2, 25, 5, 1, 0));
    // 12/1/2015 11:59 PM
    var end = new Date(Date.UTC(2016, 3, 4, 3, 0, 0));
    var now = new Date(now.getUTCFullYear(),
     now.getUTCMonth(),
     now.getUTCDate(),
     now.getUTCHours() - 5,
     now.getUTCMinutes(),
     now.getUTCSeconds());

    // Create Countdown Markup
    if (now >= start && now <= end) {
      var countdownBox = $('<div id="countdown-box"></div>');
      countdownBox.append('<div class="countdown-title"></div><span id="countdown"></span>');

      countdownBox.insertBefore('.bowtie-linebreak');

      // Countdown timer
      // update the tag with id "countdown" every 1 second
      var countdown = countdownBox.find('#countdown').get(0);
      var target_date = end.getTime();
      var days, hours, minutes, seconds;

      var countdownClock = setInterval(function () {
        // find the amount of "seconds" between now and target
        var current_date = new Date();
        current_date = new Date(current_date.getUTCFullYear(),
         current_date.getUTCMonth(),
         current_date.getUTCDate(),
         current_date.getUTCHours() - 5,
         current_date.getUTCMinutes(),
         current_date.getUTCSeconds()).getTime();
        var seconds_left = (target_date - current_date) / 1000;

        // do some time calculations
        days = parseInt(seconds_left / 86400);
        seconds_left = seconds_left % 86400;

        hours = parseInt(seconds_left / 3600);
        seconds_left = seconds_left % 3600;

        minutes = parseInt(seconds_left / 60);
        seconds = parseInt(seconds_left % 60);

        if (seconds_left >= 0) {
          // format countdown string + set tag value
          countdown.innerHTML = '<div class="days">' + '<span class="number">' + ((days < 10) ? '0' : '') + days + '</span>' + '<span class="text">days</span></div>' + '<div class="hours">' + '<span class="number">' + ((hours < 10) ? '0' : '') + hours + '</span>' + '<span class="text">hrs</span></div>' + '<div class="minutes">' + '<span class="number">' + ((minutes < 10) ? '0' : '') + minutes + '</span>' + '<span class="text">min</span></div>' + '<div class="seconds">' + '<span class="number">' + ((seconds < 10) ? '0' : '') + seconds + '</span>' + '<span class="text">sec</span></div>';
        } else {
          $('#countdown-box').remove();
          ctas.remove();
          clearInterval(countdownClock);
        }
      }, 1000);
    } else {
      ctas.remove();
    }
  }

  // Grab value of mini email signup and apply to special offers signup form
  $.urlParam = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
      return null;
    }
    else {
      return results[1] || 0;
    }
  }
  var miniEmail = decodeURIComponent($.urlParam('signup-mini-email'));
  // console.log(miniEmail);

  $('#QID2096').val(miniEmail);
});

$(document).ready(function () {
  $("#twitter-timeline-wrapper").on("DOMSubtreeModified propertychange", function () {
    twttr.widgets.load(
     document.getElementById("twitter-timeline-wrapper")
    );
    hideTweetMedia();
  });

  var hideTweetMedia = function () {
    $("#twitter-timeline-wrapper").find(".twitter-timeline").contents().find(".timeline-Tweet-media").css("display", "none");
    $("#twitter-timeline-wrapper").find(".twitter-timeline").contents().find(".timeline-TweetList").bind("DOMSubtreeModified propertychange",
     function () {
       hideTweetMedia(this);
     }
    );
  }

	if ($('[id^=g-recaptcha-response]')) { // Add required class to Captcha
		setTimeout(function(){
			var recaptcha = $('[id^=g-recaptcha-response]');
			recaptcha.addClass('required');
		}, 2000);
	}
});

$(document).ready(function () {
  if (document.URL == 'https://fontainebleau.com/schedule') {
    $('.side-info-wrapper').parent().css({
      'border-right': '1px solid #d5d5d5',
      'width': '25%',
      'border-top': 'none',
      'border-left': 'none',
      'border-bottom': 'none'
    });
  }
});

$(document).ready(function () {
  $(".seatingchart").attr("target", "_blank");

  if ($('.lang-dropdown .column:nth-child(1) a').length) {
    if ( !$('.lang-dropdown .column:nth-child(1) a').attr('href').match(/(https\:\/\/fontainebleau\.com)/) ) {
      //$('.lang-dropdown .column:nth-child(1) a').attr('href', 'https://fontainebleau.com');
    }
  }
});

$(document).ready(function() {
  $('img[src="https://segs.btrll.com/v1/tpix/-/-/-/-/-/sid.6597968"]').remove();
});

$(document).ready(function() {
  var $state = $('#social_influencer #state');
  var $country = $('#social_influencer #country');

  function setDataValue(el, val) {
    if (el.data(val) !== '') {
      el.val(el.data(val));
    }
  }

  setDataValue($state, 'state');
  setDataValue($country, 'country');
});

$(document).ready(function() {
  if ($(window).width() >= 768) {
    $('.cabana-item').not('.cabana-map').on('mouseenter', function() {
      $(this).find('.image-cover-full').addClass('visible');
    });
  
    $('.cabana-item').not('.cabana-map').on('mouseleave', function() {
      $(this).find('.image-cover-full').removeClass('visible');
    });
  }
});
